import { render, staticRenderFns } from "./WorkflowBuilder.vue?vue&type=template&id=5d2f7f04&scoped=true"
import script from "./WorkflowBuilder.vue?vue&type=script&lang=js"
export * from "./WorkflowBuilder.vue?vue&type=script&lang=js"
import style0 from "./WorkflowBuilder.vue?vue&type=style&index=0&id=5d2f7f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2f7f04",
  null
  
)

export default component.exports